import React from 'react';
import logo from '../../logo.svg';
import { Box } from '@bigcommerce/big-design';

let msg = 'Hello!';

function Home() {
  return (
    <div>
      <Box padding="medium">
        <center>
          <img src={logo} className="App-logo" alt="logo" />
          <p>{msg}</p>
        </center>
      </Box>
    </div>
  )
}

export default Home